<template>
  <SpinnerComp v-if="loading" />
  <div v-else class="flex flex-wrap justify-center gap-6 mt-8">
    <div
      class="bg-white rounded-lg flex flex-col items-center p-6 overflow-auto max-h-[500px] w-full md:w-1/2 lg:w-1/4 shadow-lg mt-8"
    >
      <form @submit.prevent="datosGraficar" class="space-y-6 w-full">
        <div class="mb-4">
          <label
            for="producto"
            class="block text-gray-800 text-sm font-semibold"
            >Selecciona un producto:</label
          >
          <select
            id="producto"
            class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
            v-model="selectedProduct"
          >
            <option v-for="dato in datos" :key="dato.id" :value="dato.id">
              {{ dato.nombre }}
            </option>
          </select>
        </div>

        <div class="mb-4">
          <label
            for="bday-month"
            class="block text-gray-800 text-sm font-semibold"
            >Fecha de inicio:</label
          >
          <input
            v-model="startDate"
            id="bday-month"
            type="month"
            name="bday-month"
            class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        <div class="mb-4">
          <label
            for="bday-month"
            class="block text-gray-800 text-sm font-semibold"
            >Fecha final:</label
          >
          <input
            v-model="endDate"
            id="bday-month"
            type="month"
            name="bday-month"
            class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
          />
        </div>

        <button
          class="mt-6 w-full bg-blue-600 text-white p-3 rounded-lg hover:bg-blue-700 transition duration-200 ease-in-out"
        >
          Generar gráfica
        </button>
      </form>
    </div>

    <div class="w-full md:w-4/6 h-1/4 flex items-center justify-center">
      <BarChart :items="items" :datasets="datasets" class="w-full" />
    </div>
  </div>
</template>

<script>
import SpinnerComp from "@/components/SpinnerComp.vue";
import BarChart from "@/components/BarChartComp.vue";

export default {
  components: {
    SpinnerComp,
    BarChart, // Incluir el componente de gráfico
  },
  data() {
    return {
      selectedProduct: null,
      startDate: "",
      endDate: "",
      loading: false,
      datos: [],
      items: [],
      datasets: [],
    };
  },

  methods: {
    getData() {
      this.loading = true;
      this.$axios
        .get("/getProName")
        .then((response) => {
          this.datos = response.data.producto.map((dato) => ({
            id: dato.id,
            nombre: dato.nombre,
          }));
        })
        .catch((error) => {
          alert(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    datosGraficar() {
      if (
        this.selectedProduct === null ||
        this.startDate === "" ||
        this.endDate === ""
      ) {
        alert("Falta información por capturar");
        return;
      }
      console.log("id del producto:", this.selectedProduct);
      this.$axios
        .get(`/stats`, {
          params: {
            id: this.selectedProduct,
            start_date: this.startDate,
            end_date: this.endDate,
          },
        })
        .then((response) => {
          this.items = response.data.items;
          this.datasets = response.data.datasets;
        })
        .catch((error) => {
          alert(error);
          console.error("Hay un problema con la api:", error);
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
